module.exports = __webpack_public_path__ + "static/media/_nato.f047a536.png";